import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import SubHeading from "../Text/SubHeading";
import Heading from "../Text/Heading";
import { popUpBody, popUpContent, popUpHeader } from "./PopUp.styled";

const PopUp = ({ popUpMessage, isOpen, onClose, popUpHeading }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent {...popUpContent}>
        <Heading {...popUpHeader} headingLabel={popUpHeading}></Heading>
        <ModalCloseButton />
        <ModalBody>
          <SubHeading
            {...popUpBody}
            subHeadingLabel={popUpMessage}
          ></SubHeading>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PopUp;
